module.exports = __webpack_public_path__ + "static/img/アセット 10@2x.3936c98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/アセット 10@2x.png
// module id = cDqf
// module chunks = 1